import React, { useEffect } from 'react';
import { gsap } from 'gsap';
import './Hero.css';

function Hero() {
  useEffect(() => {
    const handleMouseMove = (evt) => {
      const mouseX = evt.clientX;
      const mouseY = evt.clientY;

      gsap.to(".hero-shape", {
        x: mouseX,
        y: mouseY,
        stagger: -0.1,
        ease: "power2.out"
      });
    };

    const hero = document.querySelector('.hero');
    if (hero) {
      hero.addEventListener('mousemove', handleMouseMove);
      return () => {
        hero.removeEventListener('mousemove', handleMouseMove);
      };
    }
  }, []);

  return (
    <section className="hero" id="home">
      <div className="hero-shapes">
        <div className="hero-shape hero-shape-1"></div>
        <div className="hero-shape hero-shape-2"></div>
      </div>
      <div className="hero-content">
        <div className="hero-container">
          <h2 className="hero-brand">MYTHLABS</h2>
          <h1 className="hero-title">Develop. Design. Ship.</h1>
        </div>
      </div>
    </section>
  );
}

export default Hero;
